import { styles as s } from "../../styles/signupstyles";

type Props = {
  text: string;
};

export default function Divider({
  text,
}: Props) {
  return (
    <div className={s.divider}>
      <div className={s.dividerLine} />

      <span className={s.dividerText}>
        {text}
      </span>

      <div className={s.dividerLine} />
    </div>
  );
}